// src/pages/Register.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleRegister = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/clients/register`, {
        email,
        password,
      });
      alert('Registration successful! Please login.');
      navigate('/');
    } catch (error) {
      alert('Registration failed.');
      console.error(error);
    }
  };

  return (
    <div className="p-4 max-w-sm mx-auto mt-20 border rounded">
      <h2 className="text-xl font-bold mb-4">Register</h2>
      <input
        className="border p-2 w-full mb-2"
        type="text"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        className="border p-2 w-full mb-4"
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button
        className="bg-green-500 text-white px-4 py-2 w-full"
        onClick={handleRegister}
      >
        Register
      </button>
    </div>
  );
}

export default Register;
